import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { appPages, authPages } from '../../../config/pages.config';
import { useAuth } from '../../../context/authContext';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import useTabPrevention from '../../../utils/usePreventTabs';

interface IPageWrapperProps {
	children: ReactNode;
	className?: string;
	isBeforeLoginRoute?: boolean;
	isProtectedRoute?: boolean;
	checkDuplicate?: boolean;
	title?: string;
	name?: string;
}
const PageWrapper: FC<IPageWrapperProps> = (props) => {
	const { children, className, isProtectedRoute = true, isBeforeLoginRoute = false, title, name, checkDuplicate = false, ...rest } = props;

	useDocumentTitle({ title, name });

	const { userData, planData, token } = useAuth();
	if (isProtectedRoute && !userData && !token) {
		// user is not authenticated
		return <Navigate to={authPages.loginPage.to} />;
	}
	if (isBeforeLoginRoute && userData) {
		if (planData?.planEndDate && new Date(planData?.planEndDate) > new Date()) {
			window.localStorage.setItem('isSubscribed', 'true');
			return <Navigate to={appPages.dashboardPage.to} />;
		} else {
			return <Navigate to={appPages.subscriptionPage.to} />;
		}
	}

	if (isProtectedRoute && checkDuplicate) {
		useTabPrevention();
	}

	// Show the page
	return (
		<main
			data-component-name='PageWrapper'
			className={classNames('flex shrink-0 grow flex-col bg-white', className)}
			{...rest}>
			{children}
		</main>
	);
};

export default PageWrapper;
